/* eslint-disable no-unused-vars */
import { axios } from '../index'

import profileInfo from '@/jsons-data/mocks/me.json'

export default {
  /**
   * ユーザー個人情報を取得する
   */
  postUser() {
    const data = {
      data: {
        ssoIss: '473814310128',
        ssoSub: 'http://test',
        ssoSubscriptionId: 'ssoSubscriptionId',
        ssoPrincipalFlg: 0,
        ssoCustomerNo: 'ssoCustomerNo',
        ssoMembrNo: 'ssoMembrNo',
        accessToken: 'accessToken',
        refreshToken: 'refreshToken',
        idToken: 'idToken',
        loginFlag: 1,
        priceDiv: 0,
        crmFlag: 0,
        familyName: 'ベネフィット',
        firstName: '太郎',
        totalpoint: 0,
        authenticationLevel: 0,
        xbeneUser: 'string'
      }
    }
    return new Promise((resolve) => {
      return resolve(data)
    })
  },
  /**
   * ユーザー個人情報を取得する
   */
  getUser() {
    return new Promise((resolve) => {
      resolve({
        data: profileInfo
      })
    })
  },
  /**
   * ユーザー情報更新
   */
  updateUser(formData) {
    const headers = {
      'Content-Type': 'multipart/form-data'
    }
    return axios.put('/member-info', formData, headers)
  },

  contractInfo() {
    return new Promise((resolve) => {
      resolve({
        data: {
          userInfo: 'Dummy',
          contractInfo: [
            {
              companyCd: 'C10006F3W',
              customerNo: '400000000191936',
              companyName: 'テスト法人リステッドコース【A】',
              subscriptions: [
                {
                  boServiceCode: 'BS',
                  torinoMembrNo: '449901000000003'
                }
              ]
            },
            {
              companyCd: 'C10006C5V',
              customerNo: '102461000000418',
              companyName: '複数団体テスト２',
              subscriptions: [
                {
                  boServiceCode: 'BS',
                  torinoMembrNo: '102461000000418'
                }
              ]
            }
          ]
        }
      })
    })
  },
  logout() {
    return new Promise((resolve) => {
      resolve({ data: {} })
    })
  },
  getUserAddress() {
    const data = [
      {
        postalCode: '0000000'
      },
      {
        postalCode: '1000000',
        prefectureCode: 13,
        address1: '東京都千代田区',
        address2: ''
      },
      {
        postalCode: '9999999',
        prefectureCode: 13,
        address1: '東京都江戸川区平井',
        address2: '１－１－２'
      }
    ]
    return new Promise((resolve) => {
      return resolve(data)
    })
  },
  updateUserAddress() {
    const data = [
      {
        postalCode: '0000000'
      },
      {
        postalCode: '1000000',
        prefectureCode: 13,
        address1: '東京都千代田区',
        address2: ''
      },
      {
        postalCode: '1320035',
        prefectureCode: 13,
        address1: '東京都江戸川区平井',
        address2: '１－１－２'
      },
      {
        postalCode: '1000000',
        prefectureCode: 13,
        address1: '東京都江戸川区平井',
        address2: '１－１－２'
      }
    ]
    return new Promise((resolve) => {
      return resolve(data)
    })
  },
  async getPointHistory({ pointFrom, pointTo, startIndex, count, commandType }) {
    let params = {
      pointFrom,
      pointTo,
      startIndex,
      count,
      commandType
    }
    if (!pointFrom && pointTo) {
      params = {
        pointTo,
        startIndex,
        count,
        commandType
      }
    }
    if (!pointTo && pointFrom) {
      params = {
        pointFrom,
        startIndex,
        count,
        commandType
      }
    }
    if (!pointTo && !pointFrom) {
      params = {
        startIndex,
        count,
        commandType
      }
    }
    if (!commandType && pointFrom && pointTo) {
      params = {
        pointFrom,
        pointTo,
        startIndex,
        count
      }
    }
    if (!commandType && !pointFrom && !pointTo) {
      params = {
        startIndex,
        count
      }
    }
    return axios.get(`/member/point/history`, { params })
  },
  async getCafePoint() {
    return { data: { appliablePoint: 12345 } };
  }
}
